import React from "react";
import MBox from '@mui/material/Box';

const Box = (props) => {
  return <MBox   {...props}  />
}

export default Box;